import React from "react";
import { useNavigate } from "react-router";
import useShopStore from "../store/useShopStore";
import useAppStore from "../store/useAppStore";
import Button from "../utils/Button";
export default function DetailButton(props) {
  const { getProduct } = useShopStore((state) => state);
  const { success } = useAppStore((state) => state);
  const navigate = useNavigate();

  const showDetailHandler = (id) => {
    getProduct(id);
    success && navigate("/detail");
    useAppStore.setState({ success: false });
  };

  return (
    <Button class={props.class} onClick={() => showDetailHandler(props.id)}>
      {props.children}
    </Button>
  );
}
